import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { objectDetailSelector } from "redux/modules/common/building/object/nowObject";

import Select from "components/UI/atoms/Select";

import ImportDocumentation from "./_temp/_ImportDocumentation";

import { useTypedParams } from "utils/hooks/useTypedParams";
import { useUrlModuleWithObjectId } from "utils/hooks/useUrlModuleWithObjectId";

import styles from "./BuildingImportDocumentation.module.scss";

interface IProps {
  refreshSections: any;
  renderBtn?: (onClick: () => void) => ReactNode;
}

const BuildingImportDocumentation = ({ refreshSections, renderBtn }: IProps) => {
  const { objectId } = useTypedParams();
  const history = useHistory();
  const routePrefix = useUrlModuleWithObjectId();
  const objectInfo = useSelector(objectDetailSelector);

  return (
    <ImportDocumentation
      refreshSections={refreshSections}
      className={styles.import}
      renderBtn={renderBtn}
      renderDownloadBtn={(onDownload) => (
        <Select
          className={styles.seelct}
          options={[
            { name: "Новый шаблон", id: "new" },
            { name: "Шаблон из справочника", id: "handbook" },
          ]}
          onChange={(optionId) => {
            if (optionId === "new") {
              onDownload();
            } else {
              history.push(
                `/${routePrefix}/handbook/templates?objectIdForApplyTemplate=${objectId}&objectNameForApplyTemplate=${objectInfo?.name}`
              );
            }
          }}
          displayIngValue="Скачать шаблон"
        />
      )}
    />
  );
};

export default BuildingImportDocumentation;
